import {Legend} from '../model/legend.model';
import {Indirizzo} from '../../+anagrafica/entitalocale/indirizzo.model';
import {GeoIndirizzo} from '../../+geo/geoindirizzo/geo-indirizzo.model';
import {Stradario} from '../../+geo/stradario/stradario.model';
import {Helpers} from '../helpers/helpers';

export class Select2Template {

  private static entitaOrganizzativaIcon(entity): string {
    const color = entity.tipo.colore;
    const html =  Select2Template.icon('cube', color);
    return html;
  }

  private static bootstrapTooltip(label: string) {
    return 'data-toggle="\tooltip\" data-placement=\"right\" data-trigger="hover" title="' + label + '\"';
  }

  public static entitaOrganizzativa(entity, selection: boolean, placeholder: string, showAsList: boolean): string {

    if (entity instanceof Array) {
      return placeholder;
    }

    if (showAsList) {
      return null;
    } else if (selection) {
      let html = Select2Template.entitaOrganizzativaIcon(entity);
      if (entity.idnsip) {
        html = html + ' ' + entity.idnsip;
      }
      html = html + ' - ' + entity.denominazione;
      return  html;
    } else {

      let html =
        '<div class=\"d-sm-flex align-items-start\"' + Select2Template.bootstrapTooltip(entity.tipo.descr) + '>'
        +   '<div class=\"mr-1\">'
        +    Select2Template.entitaOrganizzativaIcon(entity) + '</div><div>';
      html = html + '<span><small> ' + entity.denominazione + '</small></span>';
      if (entity.sigla || entity.idnsip || entity.cdsuo) {
        html = html + '<br>';
      }
      if (entity.sigla) {
        html = html + '<span><small>  ' + entity.sigla + '</small> </span>';
      }
      if (entity.idnsip) {
        html = html + '<span><small>  <b>IdNsip:</b>' + entity.idnsip + '</small> </span>';
      }
      if (entity.cdsuo) {
        html = html + '<span><small>  <b>CDSUO:</b>' + entity.cdsuo + '</small> </span>';
      }
      if (entity.getLabelCurrentFascia()) {
        html = html + '<span><small>  ' + entity.getLabelCurrentFascia() + '</small> </span>';
      }
      if (entity.indirizzoPrincipale) {
        html = html + '<br><span><small>' + Indirizzo.getLabelComune(entity.indirizzoPrincipale.comune,
          entity.indirizzoPrincipale.siglaProvincia) + '</small></span>';
      }
      html = html + '</div></div>';

      return html;
    }
  }

  public static entitaOrganizzativaRow(entity) {
    let html = '<div ' + Select2Template.bootstrapTooltip(entity.tipo.descr) + '> ';
    html = html + Select2Template.entitaOrganizzativaIcon(entity) + ' ' + entity.denominazione + '</div>';
    return html;
  }

  public static entitaOrganizzativaSiglaCityRow(entity) {
    let html = '<div ' + Select2Template.bootstrapTooltip(entity.tipo.descr) + '> ';
    html = html + Select2Template.entitaOrganizzativaIcon(entity) + ' ' + entity.sigla;
    if (entity.indirizzoPrincipale) {
      html = html + ' - ' + entity.indirizzoPrincipale.getLabelComune();
    }
    html = html + '</div>';
    return html;
  }


  public static icon(faicon, color) {
    return '<i class=\"fa fa-' + faicon + '\" aria-hidden=\"true\" style=\"color:' + color + ';\"></i>';
  }


  public static stradario(entity, selection: boolean, placeholder: string) {

    if (!entity || selection) {
      return null;
    }

    let icon = 'map-marker';
    if (entity instanceof Stradario || entity.dug) {
      icon = 'map';
    }

    // start d-flex
    let html = '<div class=\"d-sm-flex align-items-start';
    if (entity.dug) {
      html = html + ' text-darkgreen ';
    }
    html = html + '\">'

    // div icon
    html = html +   '<div class=\"mr-1\">' + Select2Template.icon(icon, false) + '</div>';

    // div indirizzo
    html = html + '<div>';
    html = html + Select2Template.indirizzo(entity);
    html = html + '</div>';

    // close d-flex
    html = html + '</div>';
    return html;
  }

  private static indirizzo(entity) {

    if (!entity) {
      return '';
    }
    // indirizzo

    let provincia;
    let comune;
    let via;
    let civico;
    let cap;

    if (entity instanceof Indirizzo) {
      provincia = entity.provincia;
      comune = entity.comune;
      via = entity.via;
      civico = entity.civico;
      cap = entity.cap;

    } else if (entity instanceof GeoIndirizzo || entity.via) {
      provincia = entity.comune.provincia ? entity.comune.provincia.sigla : null;
      comune = entity.comune.denominazione;
      via = entity.via;
      civico = entity.civico;
      cap = entity.cap ? entity.cap.cap : null;

    } else if (entity instanceof Stradario || entity.dug) {
      provincia = entity.provincia;
      comune = entity.comune;
      via = entity.dug + ' ' + entity.denominazione;
    }

    // div indirizzo content

    let html = via;
    if (civico) {
      html = html + ' ' + civico + ' ';
    }
    if (comune || provincia || cap) {
      html = html + ' - <span><small> ';
      if (comune) {
        html = html + comune;
      }
      if (provincia) {
        html = html + ' (' + provincia + ') ';
      }
      if (cap) {
        html = html + cap;
      }
      html = html + '</small></span>';
    }


    return html;
  }

  public static entitaLocale(entity, selection: boolean, placeholder: string) {

    if (!entity || selection) {
      return null;
    }

    // start d-flex
    let html = '<div class=\"d-sm-flex align-items-start';
    if (entity.dug) {
      html = html + ' text-darkgreen ';
    }
    html = html + '\">'

    // div icon
    html = html + '<div class=\"mr-3\">' + Select2Template.icon('map-marker', false) + '</div>';

    // div contenuto
    html = html + '<div>';

    html = html + '<em><small>' + entity.tipo.getLabel() + '</small></em><br>';

    if (entity.descr) {
      html = html + '<strong>' + entity.descr + '</strong><br>';
    }
    html = html + Select2Template.indirizzo(entity.getIndirizzoDisponibile()) + '<br>';

    const times = entity.entitaOrganizzative.length === 1 ? ' volta' : ' volte';
    html = html + '<small class="text-secondary">' + 'Utilizzata ' + entity.entitaOrganizzative.length + times + '</small>';

    html = html + '</div>';

    // close d-flex
    html = html + '</div>';

    return html;
  }

  private static personaIcon(entity, color): string {
    const html =  Select2Template.icon('user', color);
    return html;
  }

  public static persona(entity, selection: boolean, placeholder: string, showAsList: boolean): string {
    if (entity instanceof Array) {
      return placeholder;
    }

    if (showAsList) {
      return null;
    } else if (selection) {
      return Select2Template.personaIcon(entity, 'info') + ' ' + entity.getLabel();
    } else {

      let html =
        '<div class=\"d-sm-flex align-items-start\"' + Select2Template.bootstrapTooltip(entity.getLabel()) + '>'
        +   '<div class=\"mr-1\">'
        +    Select2Template.personaIcon(entity, 'info') + '</div><div class="w-100">';
      html = html + '<span><small> ' + entity.getLabel() + '</small>';
      if (entity.dataNascita)
        html = html + '<i><small> (' + Helpers.showDate(entity.dataNascita) + ')</small></i></span>';
      if (entity.dipendente) {
        html = html + '<span class="pull-right"><span class="badge badge-info"><small>dipendente</small></span></span>';
      }
      if (entity.sede)
        html = html + '<br><span><small>' + entity.sede.getSigla() + '</small> </span>';
      if (entity.matricola)
        html = html + '<br><span><small><b>Matr:</b> ' + entity.matricola + '</small> </span>';
      if (entity.livelloProfilo) {
        if (entity.matricola)
          html = html + ' - ';
        html = html + '<span><small>[' + entity.livelloProfilo + ']</small> </span>';
      }
      if (entity.siperRecapito) {
        if (entity.siperRecapito.getLabel())
          html = html + '<br><span class="align-items-center">' + Select2Template.icon('home', 'info') + '<small class="ml-2">' + entity.siperRecapito.getLabel() + '</small> </span>';
        if (entity.siperRecapito.telefono)
          html = html + '<br><span class="align-items-center">' + Select2Template.icon('phone', 'info') + '<small class="ml-2 mr-2">' + entity.siperRecapito.telefono + '</small> </span>';
        if (entity.siperRecapito.cellulare)
          html = html + '<span class="align-items-center">' + Select2Template.icon('mobile', 'info') + '<small class="ml-2">' + entity.siperRecapito.cellulare + '</small> </span>';
      }

      html = html + '</div></div>';

      return html;
    }
  }

  public static utente(entity, selection: boolean, placeholder: string): string {

    if (entity instanceof Array) {
      return placeholder;
    }

    if (selection) {
      return Select2Template.personaIcon(entity, 'primary') + ' ' + entity.getLabel();
    } else {

      let html =
        '<div class=\"d-sm-flex align-items-start\"' + Select2Template.bootstrapTooltip(entity.getLabel()) + '>'
        +   '<div class=\"mr-1\">'
        +    Select2Template.personaIcon(entity, 'primary') + '</div><div>';
      html = html + '<span><small> ' + entity.getLabel() + '</small></span>';
      if (entity.persona) {
        html = html + '<br>';
        html = html + '<span><small>  ' + entity.persona.getLabel() + '</small> </span>';
      }
      if (entity.persona && entity.persona.sede) {
        html = html + '<br>';
        html = html + '<span><small>  ' + entity.persona.sede.getSigla() + '</small> </span>';
      }
      if (entity.persona && entity.persona.matricola) {
        html = html + '<br><span><small>  ' + entity.persona.matricola + '</small> </span>';
      }
      html = html + '</div></div>';

      return html;
    }
  }

  private static ruoloIcon(color): string {
    const html =  Select2Template.icon('graduation-cap', color);
    return html;
  }

  public static ruolo(entity, selection: boolean, placeholder: string, detail: boolean, showAsList: boolean): string {

    if (entity instanceof Array) {
      return placeholder;
    }

    if (showAsList) {
      return null;
    } else if (selection) {
      return Select2Template.ruoloIcon('primary') + ' ' + entity.descr;
    } else {

      let html =
        '<div class=\"d-sm-flex align-items-start\"' + Select2Template.bootstrapTooltip(entity.descr) + '>'
        +   '<div class=\"mr-1\">'
        +    Select2Template.ruoloIcon('primary') + '</div><div>';
      html = html + '<span><small> ' + entity.descr + '</small></span>';
      if (entity.sigla) {
        html = html + '<br>';
        html = html + '<span><small>Sigla: ' + entity.sigla + '</small> </span>';
      }
      if (detail && entity.contesto) {
        html = html + '<br>';
        html = html + '<span><small>Contesto: ' + entity.contesto.sigla + '</small> </span>';
      }
      html = html + '</div></div>';

      return html;
    }
  }

  public static ruoloWithDetail(entity, selection: boolean, placeholder: string, showAsList: boolean): string {
    return Select2Template.ruolo(entity, selection, placeholder, true, showAsList);
  }

  private static contestoIcon(color): string {
    const html =  Select2Template.icon('object-group', color);
    return html;
  }

  public static contesto(entity, selection: boolean, placeholder: string): string {

    if (entity instanceof Array) {
      return placeholder;
    }

    if (selection) {
      return Select2Template.contestoIcon('primary') + ' ' + entity.descr;
    } else {

      let html =
        '<div class=\"d-sm-flex align-items-start\"' + Select2Template.bootstrapTooltip(entity.descr) + '>'
        +   '<div class=\"mr-1\">'
        +    Select2Template.contestoIcon('primary') + '</div><div>';
      html = html + '<span><small> ' + entity.descr + '</small></span>';
      if (entity.sigla) {
        html = html + '<br>';
        html = html + '<span><small>  ' + entity.sigla + '</small> </span>';
      }
      html = html + '</div></div>';

      return html;
    }
  }
}
